/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_SubscriptionsInputs */

const en_admin_nav_subscriptions = /** @type {(inputs: Admin_Nav_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Admin_Nav_SubscriptionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_subscriptions = /** @type {((inputs?: Admin_Nav_SubscriptionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_SubscriptionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_subscriptions(inputs)
});
export { admin_nav_subscriptions as "admin.nav.subscriptions" }